module.exports = "img/flags/GT.55c941d.png";